var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import cx from 'classnames';
import * as S from './styles';
export var GridItem = forwardRef(function GridItem(_a, ref) {
    var children = _a.children, small = _a.small, medium = _a.medium, large = _a.large, xlarge = _a.xlarge, className = _a.className, style = _a.style, rest = __rest(_a, ["children", "small", "medium", "large", "xlarge", "className", "style"]);
    var smallClassName = typeof small === 'number' && "gi-" + small + "-small";
    var mediumClassName = typeof medium === 'number' && "gi-" + medium + "-medium";
    var largeClassName = typeof large === 'number' && "gi-" + large + "-large";
    var xlargeClassName = typeof xlarge === 'number' && "gi-" + xlarge + "-extra-large";
    var rootClass = cx(className, smallClassName, mediumClassName, largeClassName, xlargeClassName);
    return (React.createElement(S.GridItem, __assign({ className: rootClass, style: style, ref: ref }, rest), children));
});
GridItem.displayName = 'GridItem';
export default GridItem;
//# sourceMappingURL=GridItem.js.map